// shared-types/src/chatbot/tone.ts

export const CHATBOT_TONE_IDS = [
    'professional',
    'friendly',
    'concise',
    'enthusiastic',
    'formal',
    'casual',
] as const

export type ChatbotToneId = (typeof CHATBOT_TONE_IDS)[number]

export const DEFAULT_CHATBOT_TONE: ChatbotToneId = 'professional'

export function isChatbotToneId(value: string): value is ChatbotToneId {
    return (CHATBOT_TONE_IDS as readonly string[]).includes(value)
}
